import { restClient } from '../config/restClient'

const endpoint = hiringTeamId => `/api/company/v2/hiring_teams/${hiringTeamId}/job_openings`
const endpoint_LEGACY = hiring_team_id => `/api/hiring_teams/${hiring_team_id}/job_openings`

export const getPositions = async (hiringTeamId, params) => {
  const response = await restClient(endpoint(hiringTeamId), {
    method: 'GET',
    params,
  })
  return response.data
}

export const getPositions_LEGACY = async (hiringTeamId, params) => {
  const response = await restClient(endpoint_LEGACY(hiringTeamId), {
    method: 'GET',
    params,
  })
  return response.data
}

export const getPosition = async (hiringTeamId, positionId) => {
  const response = await restClient(`${endpoint(hiringTeamId)}/${positionId}`, {
    method: 'GET',
  })

  return response.data
}

export const patchPosition = async (hiringTeamId, positionId, data) => {
  const response = await restClient(`${endpoint(hiringTeamId)}/${positionId}`, {
    method: 'PATCH',
    data,
  })

  return response.data
}

export const postPosition = async (hiring_team_id, data) => {
  const response = await restClient(endpoint(hiring_team_id), {
    method: 'POST',
    data,
  })

  return response.data
}
